/* The shop slider, ported from Shop.dc.html (2026-08-10 handoff).
   Piecewise track (1-50 owns ~54% of the drag), canonical 8-tier ladder.
   Cart contract: adds the single mullet-bag variant at qty = headcount; the
   quantity-break app applies the tier discount server-side. */
(function () {
  var root = document.querySelector('[data-mps]');
  if (!root) return;

  /* Canonical ladder. Per-unit price = highest tier minimum <= qty. */
  var TIERS = [[1, 25], [10, 20], [25, 17], [50, 14], [100, 11], [250, 8], [500, 6], [1000, 5]];
  /* [qtyMin, qtyMax, trackMin, trackMax] */
  var SEGS = [
    [1, 10, 0, 140], [10, 25, 140, 320], [25, 50, 320, 540], [50, 100, 540, 700],
    [100, 250, 700, 820], [250, 500, 820, 910], [500, 1000, 910, 1000]
  ];

  var el = {
    range: root.querySelector('[data-mps-range]'),
    qty: root.querySelector('[data-mps-qty]'),
    zone: root.querySelector('[data-mps-zone]'),
    per: root.querySelector('[data-mps-per]'),
    total: root.querySelector('[data-mps-total]'),
    save: root.querySelector('[data-mps-save]'),
    amazon: root.querySelector('[data-mps-amazon]'),
    nudge: root.querySelector('[data-mps-nudge]'),
    buy: root.querySelector('[data-mps-buy]'),
    buyQty: root.querySelector('[data-mps-buy-qty]'),
    buyTotal: root.querySelector('[data-mps-buy-total]')
  };

  var qty = 20;
  var nudgeQty = null;

  function fmt(n) { return '$' + n.toLocaleString('en-US'); }

  function qtyToSlider(q) {
    for (var i = 0; i < SEGS.length; i++) {
      var s = SEGS[i];
      if (q <= s[1]) return s[2] + ((q - s[0]) / (s[1] - s[0])) * (s[3] - s[2]);
    }
    return 1000;
  }

  function sliderToQty(v) {
    for (var i = 0; i < SEGS.length; i++) {
      var s = SEGS[i];
      if (v <= s[3]) return Math.round(s[0] + ((v - s[2]) / (s[3] - s[2])) * (s[1] - s[0]));
    }
    return 1000;
  }

  /* The track is piecewise, so one slider step is worth a fraction of a mullet
     down low and about 5 up top. Dragging to the 100 mark could land on 99 and
     quote the 50 tier price, which reads as a bug. Make the tier values
     magnetic, with a tolerance proportional to the local resolution so the low
     end stays precise and only the compressed top end pulls. */
  function qtyPerSliderUnit(v) {
    for (var i = 0; i < SEGS.length; i++) {
      var s = SEGS[i];
      if (v <= s[3]) return (s[1] - s[0]) / (s[3] - s[2]);
    }
    return (SEGS[SEGS.length - 1][1] - SEGS[SEGS.length - 1][0]) / 90;
  }

  function snapToTier(q, sliderVal) {
    var tol = Math.max(1, Math.round(qtyPerSliderUnit(sliderVal) * 2));
    for (var i = 0; i < TIERS.length; i++) {
      if (Math.abs(q - TIERS[i][0]) <= tol) return TIERS[i][0];
    }
    return q;
  }

  function perFor(q) {
    var p = 25;
    for (var i = 0; i < TIERS.length; i++) if (q >= TIERS[i][0]) p = TIERS[i][1];
    return p;
  }

  function render(syncSlider) {
    var per = perFor(qty);
    var total = qty * per;
    el.qty.textContent = qty;
    el.zone.textContent = qty >= 100 ? 'RECEPTION MODE' : qty >= 25 ? 'CREW MODE' : 'SQUAD MODE';
    el.per.textContent = fmt(per);
    el.total.textContent = fmt(total);
    el.save.textContent = 'You save ' + fmt(qty * 25 - total) + ' vs one at a time';
    el.amazon.textContent = fmt(qty * 30 - total) + ' cheaper than Amazon';
    el.buyQty.textContent = qty;
    el.buyTotal.textContent = fmt(total);

    var next = null;
    for (var i = 0; i < TIERS.length; i++) if (TIERS[i][0] > qty) { next = TIERS[i]; break; }
    if (next && next[0] - qty <= Math.max(5, Math.round(qty * 0.3))) {
      nudgeQty = next[0];
      el.nudge.textContent = (next[0] - qty) + ' more → ' + fmt(next[1]) + ' each';
      el.nudge.hidden = false;
    } else {
      nudgeQty = null;
      el.nudge.hidden = true;
    }

    if (syncSlider) el.range.value = Math.round(qtyToSlider(qty));
    el.range.setAttribute('aria-valuetext', qty + ' mullets');
  }

  function setQty(q, syncSlider) {
    qty = Math.min(1000, Math.max(1, q));
    render(syncSlider !== false);
  }

  el.range.addEventListener('input', function () {
    var raw = Number(el.range.value);
    var q = sliderToQty(raw);
    var snapped = snapToTier(q, raw);
    // When it snaps, sync the thumb too so it settles exactly on the tick.
    setQty(snapped, snapped !== q);
  });
  el.nudge.addEventListener('click', function () { if (nudgeQty) setQty(nudgeQty); });
  document.querySelectorAll('[data-mps-pack]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      setQty(parseInt(btn.getAttribute('data-mps-pack'), 10));
      root.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  /* ---- add to cart ---- */
  function refreshCartPill() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-mpx-cart-count]').forEach(function (n) {
        n.textContent = 'Cart (' + cart.item_count + ')';
      });
    }).catch(function () {});
  }

  el.buy.addEventListener('click', function () {
    var vid = window.MPX_BAG_VARIANT;
    if (!vid) { window.location.href = '/cart'; return; }
    if (el.buy.dataset.adding === '1') return;
    el.buy.dataset.adding = '1';
    el.buy.setAttribute('aria-busy', 'true');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: vid,
        quantity: qty,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (state) {
        el.buy.dataset.adding = '0';
        el.buy.removeAttribute('aria-busy');
        refreshCartPill();
        var drawer = document.querySelector('cart-drawer');
        if (drawer && state && state.sections) { drawer.renderContents(state); }
        else { window.location.href = '/cart'; }
      })
      .catch(function () {
        el.buy.dataset.adding = '0';
        el.buy.removeAttribute('aria-busy');
        window.location.href = '/cart';
      });
  });

  render(true);
})();

(function () {
  var dialog = document.querySelector('[data-mps-insurance]');
  var open = document.querySelector('[data-mps-insurance-open]');
  if (!dialog || !open || !dialog.showModal) return;
  open.addEventListener('click', function () { dialog.showModal(); });
  dialog.querySelector('[data-mps-insurance-close]').addEventListener('click', function () { dialog.close(); });
  dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
})();
